// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatInspectRequest" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatRouteStateGenShape } from "./chat-route-state.gen";

export const ChatInspectRequestGenShape = z.strictObject({
  workflowDocumentId: z.string(),
  libraryId: z.string(),
  message: z.string(),
  state: ChatRouteStateGenShape,
  useResultCache: z.boolean(),
});
